export default {
	init() {
		setup_project_trigger();
	},
};

function setup_project_trigger()
{
	$('a.project-trigger').click(function(e){
		e.preventDefault();
		let trigger = $(this);
		let parent = $(this).parent();
		let content = parent.find('.project-details__content');
		if(content.is(':visible'))
		{
			trigger.removeClass('active');
			content.slideUp('fast');
		}
		else
		{
			trigger.addClass('active');
			content.slideDown('fast');
		}
	})
}



// WEBPACK FOOTER //
// ./scripts/routes/project.js